// src/features/auth/Login.jsx (refactorizado)
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CustomSnackbar from '../../components/CustomSnackbar';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();  // Extraemos login del AuthContext refactorizado
  const [user, setUser] = useState({ username: '', password: '' });
  const [displaySnackbar, setDisplaySnackbar] = useState({
    type: '',
    message: '',
    open: false
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setUser(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleAuthUser = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      // Usamos el método login del contexto refactorizado
      const success = await login(user.username, user.password);
      
      if (success) {
        setDisplaySnackbar({
          type: 'success',
          message: 'Login Exitoso',
          open: true
        });
        
        // Redirigimos a /people después de un breve delay
        setTimeout(() => {
          navigate('/people');
        }, 1000);
      } else {
        setDisplaySnackbar({
          type: 'error',
          message: 'Error en usuario / contraseña',
          open: true
        });
      }
    } catch (error) {
      console.error('Error de autenticación:', error);
      setDisplaySnackbar({
        type: 'error',
        message: 'Ocurrió un error en el login',
        open: true
      });
    } finally {
      setLoading(false);
    }
  };

  const closeSnackbar = () => {
    setDisplaySnackbar({ type: '', message: '', open: false });
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '400px' }}>
      <Row className="justify-content-center">
        <Col>
          <div className="text-center mb-4">
            <img
              src="LogoClauger.jpeg"
              alt="logo"
              style={{ maxHeight: '80px' }}
            />
          </div>
          <Form onSubmit={handleAuthUser}>
            <Form.Group controlId="username" className="mb-3">
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                type="text"
                name="username"
                value={user.username}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </Form.Group>
            <Form.Group controlId="password" className="mb-3">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={user.password}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </Form.Group>
            <Button 
              variant="primary" 
              type="submit" 
              className="w-100"
              disabled={loading}
            >
              {loading ? 'Autenticando...' : 'Ingresar'}
            </Button>
          </Form>
        </Col>
      </Row>

      <CustomSnackbar
        type={displaySnackbar.type}
        onClose={closeSnackbar}
        message={displaySnackbar.message}
        open={displaySnackbar.open}
      />
      <div className="text-center mt-4 text-muted">
        &copy; {new Date().getFullYear()} Clauger SGA
      </div>
    </Container>
  );
}

export default Login;